import React, { Component } from "react";
import { connect } from "react-redux";
import { FaPrescription } from "react-icons/fa";
import { Divider, Modal } from "antd";
import { DoctorPrescriptionModal } from "./stylingRx.styled";

export class DoctorRx extends Component {
  state = {
    showMultiPdfModal: false,
  };

  downloadDrx = () => {
    if (this.props.dataPdf.length === 0 && this.props.dataImg.length === 1) {
      this.props.toggleVisible(true);
    } else if (
      this.props.dataPdf.length === 1 &&
      this.props.dataImg.length === 0
    ) {
      this.props.viewCurrPDF(this.props.dataPdf[0]);
    } else {
      this.setState({
        showMultiPdfModal: true,
      });
    }
  };

  render() {
    let { dataImg, dataPdf, type } = this.props;
    return (
      <>
        <button
          className="bbtn"
          onClick={() => this.downloadDrx()}
          disabled={
            (!dataImg && !dataPdf) ||
            (dataImg?.length === 0 && dataPdf?.length === 0)
          }
        >
          View {`${type === 1 ? "Customer" : "Doctor"}`}'s <FaPrescription />
        </button>

        <DoctorPrescriptionModal
          wrapClassName="updateMedBatchModal"
          // title={`${type === 1 ? "Customer" : "Doctor"}'s Prescriptions`}
          open={this.state.showMultiPdfModal}
          footer={null}
          onCancel={() => this.setState({ showMultiPdfModal: false })}
        >
          <div className="doctorRxContainer">
            <Divider>
              View <FaPrescription />
            </Divider>

            {!dataImg || dataImg.length === 0 ? null : (
              <button
                className="bbtn"
                onClick={() => this.props.toggleVisible(true)}
                disabled={!dataImg || dataImg.length === 0}
              >
                <FaPrescription /> View IMGs
              </button>
            )}

            {dataPdf?.map((k, p) => (
              <button
                key={p}
                className="bbtn"
                onClick={() => this.props.viewCurrPDF(k)}
              >
                <FaPrescription /> View PDF #{Number(p) + 1}
              </button>
            ))}
          </div>
        </DoctorPrescriptionModal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DoctorRx);
